import { useMembersContext } from '@/contexts/membersContext';
import { Substance } from '@/types/substance';
import ajax from '@/utils/ajax';

export interface SubstanceParams {
  drug_category?: string;
}

export const substanceRepository = {
  BASE_PATH: '/api/program/substances/',

  async list({ host, params }: { host: string; params?: SubstanceParams }): Promise<Substance[]> {
    const response = await ajax.get({
      url: `${host}${this.BASE_PATH}`,
      params: {
        ...params
      }
    });

    return response.data;
  }
};

export const SubstanceRepository = () => {
  const { host } = useMembersContext();

  return {
    async list(params: SubstanceParams) {
      return substanceRepository.list({ host, params });
    }
  };
};
